module.exports = __webpack_public_path__ + "static/testimonial-4-31814da7ea3cb13a89f82fa520a9719d.png";